import { render } from "./ReportResponses.vue?vue&type=template&id=312793a8"
import script from "./ReportResponses.vue?vue&type=script&lang=js"
export * from "./ReportResponses.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__